import { NumberField } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PreferencesTab/CustomComponents/Currency';
import React, { useState } from 'react';

export const DecimalField = ({ value, onChange, ...props }) => {
  const [isFocused, setIsFocused] = useState(false);
  const handleChange = (newValue: string) => {
    if (isNaN(Number.parseFloat(newValue))) {
      onChange(prevState => newValue === '' ? null : prevState);
      return;
    };
    
    let formattedStringValue: string;
    if  (!newValue.includes('.')) {
      formattedStringValue = newValue.length > 3 
        ? newValue.substring(0, 3) + '.' + newValue.substring(3, 5) 
        : newValue;
    } else {
      const decParts = newValue.split('.', 2);
      const fractionalStartIndex = decParts[0].length > 3 ? 3 : decParts[0].length;
      formattedStringValue = decParts[0].substring(0, 3) + '.' + (
        newValue.replace('.', '').substring(fractionalStartIndex, fractionalStartIndex + 2)
      );
    }
    onChange(formattedStringValue);
  };

  const handleBlur = () => {
    const parsedValue = Number.parseFloat(value);
    if (Number.isInteger(parsedValue))
      onChange(parsedValue.toFixed(2));
    setIsFocused(false);
  }; 

  const handleFocus = () => {
    setIsFocused(true);
  };

  return (
    <NumberField 
      {...props}
      type="number" 
      value={value}
      variant="filled"
      onChange={(e) => handleChange(e.target.value)}
      onBlur={handleBlur}
      onFocus={handleFocus}
      inputProps={{ step: '0.01' }}
      InputProps={{
        ...props.InputProps,
        endAdornment: !!value || isFocused ? props.InputProps.endAdornment : undefined,
        startAdornment: !!value || isFocused ? props.InputProps.startAdornment : undefined,
      }}
    />
  );
}